export const STANLEY_QUERY_KEYS = {
  POST_SUGGESTIONS: 'STANLEY_QUERY_POST_SUGGESTIONS',
  GET_MEMBERSHIP_SIZE: 'STANLEY_QUERY_GET_MEMBERSHIP_SIZE',
  GET_HISTORY: 'STANLEY_QUERY_GET_HISTORY',
  GET_HISTORY_ITEM: 'STANLEY_QUERY_GET_HISTORY_ITEM',
  DELETE_HISTORY_ITEM: 'STANLEY_QUERY_DELETE_HISTORY_ITEM',
  RENAME_HISTORY_ITEM: 'STANLEY_QUERY_RENAME_HISTORY_ITEM',
  GET_CREDITS: 'STANLEY_QUERY_GET_CREDITS',
} as const;

const STANLEY_APP_SERVICES_BASE_URL = {
  develop: 'https://develop-app-services.helixa.ai',
  staging: 'https://staging-app-services.helixa.ai',
  production: 'https://app-services.helixa.ai',
} as const;

type ApiEnv = keyof typeof STANLEY_APP_SERVICES_BASE_URL;

const apiEnv = (process.env.REACT_APP_API_ENV ?? 'develop') as ApiEnv;

export const STANLEY_QUERY_BUILDER_URL =
  process.env.REACT_APP_STANLEY_AI_QUERY_BUILDER_URL ??
  `${STANLEY_APP_SERVICES_BASE_URL[apiEnv]}/ai/query_builder`;
